module.exports = __webpack_public_path__ + "img/0-02-0a-4c40585223b6903736c8d3282d2e6c525f1beaea8a848a7e01c3a89345fc5366_8527b03c.8912034b.jpg";